/* istanbul ignore file */
// we don't test SVGs without arguments
import React from 'react'
import PropTypes from 'prop-types'

const CaretIconSmall = () => (
  <svg
    className="caret-icon-small"
    fill="none"
    height="7"
    viewBox="0 0 12 7"
    width="12"
  >
    <path
      d="M1 6L6 1L11 6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
)

CaretIconSmall.propTypes = {
  color: PropTypes.string,
  rotation: PropTypes.number,
}

export default CaretIconSmall
